import type { TextareaHTMLAttributes } from "react";

export interface TextareaFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
}

/** A labelled multi-line text input — the textarea form vocabulary. Token-styled, resizes vertically. */
export function TextareaField({ label, ...rest }: TextareaFieldProps) {
  return (
    <label className="fui-field">
      <span className="fui-field__label">{label}</span>
      <textarea className="fui-field__input" {...rest} />
    </label>
  );
}
